<template>
  <div>
    <q-chip>Test</q-chip>
  </div>
</template>

<script>
export default {
  name: 'ChipTemplate',
  props: [],
  methods: {
  }
}
</script>

<style>
</style>
